import React from 'react';
import { UploadFileOutlined } from '@mui/icons-material';
import { UploadedProviderDocument, uploadedProviderDocumentTypeLabels } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';
import { useTimezone } from '@uplift/contexts';
import { DocumentListItemRow } from './DocumentListItemRow';


export const UploadedProviderDocumentListItem: React.VFC<{
  document: UploadedProviderDocument;
  datetime: string;
  onClick: () => void;
  selected: boolean;
}> = ({ document, datetime, onClick, selected }) => {
  const timezone = useTimezone();

  return (
    <DocumentListItemRow
      name={uploadedProviderDocumentTypeLabels[document.documentType] ?? document.documentType}
      status={`Uploaded ${CalendarDateService.date(datetime).tz(timezone).format(DateFormats['MMM D, YYYY'])}`}
      statusColor="neutral"
      icon={<UploadFileOutlined />}
      onClick={onClick}
      selected={selected}
    />
  );
};
